import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStoreManager } from './local-store-manager.service';
import { EmployeeGroup } from '../models/employeegroup.model';

@Injectable()
export class EmployeeGroupService {
  private employeegroupUrl: string = 'api/employeegroups';

  constructor(
    private http: HttpClient,
    private localStorage: LocalStoreManager) { }

  getEmployeeGroups(): Observable<EmployeeGroup[]> {
    let sitename = this.localStorage.getDataObject("sitename");
    let endpointUrl = `${this.employeegroupUrl}/${sitename}`;
    return this.http.get<EmployeeGroup[]>(endpointUrl);
  }

}

